<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes } = useMessageContext();
const { t } = useI18n();

const buttonData = computed(() => {
  const attrs = contentAttributes.value || {};

  return {
    header: attrs.header || attrs.title || '',
    body: attrs.body || content.value || '',
    footer: attrs.footer || '',
    buttons: attrs.buttons || attrs.actions || [],
  };
});

const hasHeader = computed(() => !!buttonData.value.header);
const hasFooter = computed(() => !!buttonData.value.footer);
const hasButtons = computed(() => buttonData.value.buttons.length > 0);

function getButtonText(button) {
  if (typeof button === 'string') return button;
  return (
    button.text || button.title || button.buttonText || button.displayText || ''
  );
}
</script>

<template>
  <BaseBubble
    class="overflow-hidden p-3 min-w-48 max-w-sm"
    data-bubble-name="interactive-buttons"
  >
    <div class="space-y-3">
      <!-- Header -->
      <div v-if="hasHeader" class="text-sm font-semibold text-n-slate-12">
        {{ buttonData.header }}
      </div>

      <!-- Body -->
      <div
        v-if="buttonData.body"
        class="text-sm text-n-slate-12 whitespace-pre-wrap"
      >
        {{ buttonData.body }}
      </div>

      <!-- Footer -->
      <div v-if="hasFooter" class="text-xs text-n-slate-11">
        {{ buttonData.footer }}
      </div>

      <!-- Buttons (read-only display) -->
      <div v-if="hasButtons" class="space-y-2 pt-2 border-t border-n-weak">
        <div
          v-for="(button, index) in buttonData.buttons"
          :key="index"
          class="w-full px-4 py-2 rounded-lg text-sm text-center bg-n-alpha-2 text-woot-600 border border-n-weak cursor-default"
        >
          {{ getButtonText(button) }}
        </div>
      </div>

      <!-- Read-only indicator -->
      <div v-if="hasButtons" class="text-xs text-n-slate-10 text-center italic">
        {{ t('CONVERSATION.INTERACTIVE.BUTTONS_READ_ONLY') }}
      </div>
    </div>
  </BaseBubble>
</template>
